<template>
  <responsive-menu
    force-on-mobile
    card-style="width: 300px;"
    :toolbar-title="title"
    @hide="changedStatus = false"
  >
    <q-inner-loading
      :showing="loading"
      style="z-index: 3;"
    >
      <loading-spinner />
    </q-inner-loading>

    <q-list :dense="!$q.platform.has.touch">
      <q-item-wrapper
        v-for="(ele, key) in statusOptions"
        :key="key"
        :label="ele.label"
        :caption="ele.caption"
        :label-class="ele.disable ? 'text-grey-6' : ''"
        tag="label"
      >
        <template #before>
          <q-item-section side>
            <q-radio
              :model-value="status"
              class="color-inherit q-ml-sm"
              dense
              :disable="ele.disable"
              :color="ele.color"
              :val="ele.value"
              :style="{'color': ele.hex_color}"
              @update:model-value="updateStatusTimer"
            />
          </q-item-section>
        </template>
      </q-item-wrapper>
    </q-list>

    <slot :changed-status="changedStatus" />
  </responsive-menu>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    statusOptions: {
      type: Array,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  emits: ['update:status', 'saveStatus'],
  data () {
    return {
      loading: false,
      changedStatus: false,
      timer: null,
      showNote: false
    }
  },
  methods: {
    updateStatusTimer (val) {
      this.$emit('update:status', val)
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        this.loading = true
        this.$emit('saveStatus', (changeStatus = true) => {
          this.loading = false
          this.changedStatus = changeStatus
        })
      }, 500)
    }
  }
}
</script>
